import { render, staticRenderFns } from "./CustomersByAgeGroup.vue?vue&type=template&id=febecef0"
import script from "./CustomersByAgeGroup.vue?vue&type=script&lang=js"
export * from "./CustomersByAgeGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports